import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { getSelectFitCategories } from "../services/RetailLocationService";

export function useSelectFitCategories(enabled = true, resetKey, callback = () => {}, params) {

    const [selectFitCategories, setSelectFitCategories] = useState([]);

    const {data} = useQuery({
        queryKey: ['selectFitCategories', resetKey, params],
        queryFn: () => getSelectFitCategories(params),
        retry: false,
        enabled: enabled,
    })

    useEffect(() => {
        if (data) {
            setSelectFitCategories(data.selectFitCategories);
            callback(data.selectFitCategories);
        }
    }, [data]);

    return selectFitCategories;
}